import { MemoryStorage, storage } from "local-storage-fallback";
import _ from "underscore";

const memStorage = new MemoryStorage();

class Storage {
  static current() {
    return Storage.rememberMe() ? storage : memStorage;
  }

  static getItem(key) {
    return Storage.current().getItem(key);
  }

  static setItem(key, val) {
    Storage.current().setItem(key, val);
  }

  static removeItem(key) {
    storage.removeItem(key);
    memStorage.removeItem(key);
  }

  static clear() {
    storage.clear();
    memStorage.clear();
  }

  static setRememberMe(remember) {
    storage.setItem("rememberMe", remember);

    if (!remember) return;

    _.each(["sessionToken", "customerName"], (key) => {
      if (memStorage.getItem(key)) {
        storage.setItem(key, memStorage.getItem(key));
        memStorage.removeItem(key);
      }
    });
  }

  static rememberMe() {
    return _.contains(["true", null], storage.getItem("rememberMe"));
  }
}

export default Storage;
